import { render, staticRenderFns } from "./purchasetype.vue?vue&type=template&id=4eeea0cb&"
import script from "./purchasetype.vue?vue&type=script&lang=js&"
export * from "./purchasetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports